


(function ($) {
    'use_strict';

    var currentSortValue = null;

    $.support.cors = true;

    var getUrlParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * Apartment selector 2016
     * Author: Fabriken Webbyrå AB
     * Year:2016
     * Useage example:
     * $(document).ready(function () {
     $("#bostadsvaljare").apartmentSelector(
     {
     appID: "4DOADLFD0DOGS9J6", //Project ID
     views: 2, //Views check apartments folder for the count of views.
     debug: false
     }
     );
     });
     * @param {Object} options
     * @returns {undefined}
     */
    $.fn.apartmentSelector = function (options) {

        //__construct
        var self = this;
        self.settings = $.extend({
            jsonUrl: "",
            appID: "",
            views: 0,
            defaultView: 1,
            //appUrl: "http://app.local/apibostadsvaljaren/",
            appUrl: "https://api.bostadsvaljaren.se/",
            images: [],
            doubleClickOnDevice: false,
            navigate: true,
            do_ajax: false,
            new_page: false,
            debug: false,
            width: 1920,
            height: 1080,
            apartmentsInTable: 13,
            theme: 'default'
        }, options);

        self.houses = [
            { name: 'H01', count: 0 },
            { name: 'H02', count: 0 },
            { name: 'H03', count: 0 },
            { name: 'H04', count: 0 },
            { name: 'H05', count: 0 },
            { name: 'H06', count: 0 }, 
            { name: 'H07', count: 0 }, 
            { name: 'H08', count: 0 }, 
        ];

        if (self.settings.jsonUrl === "" || self.settings.appID === "" || !supportsSVG()) {
            self.remove();
            // console.log("Invalid settings for apartmentSelector");
            return false;
        }

        if(self.settings.debug){
            self.settings.appUrl += "dev/";
        }

        self.defaultView = 1;

        

        self.settings.jsonUrl = self.settings.jsonUrl + self.settings.appID;
        self.dom_id = $(this).attr("id");
        self.activeView = "";
        self.apartments = [];
        self.statusTypes = [['available', 'Ledig'],['no_sale', 'Ikke til salgs'], ['reserved', 'Reservert'], ['booked', 'Bestilt'], ['sold', 'Solgt'], ['sell_later', 'Selges senere'], ['display', 'Display Innkapsling'], [null, '-']];
        self.svgViews = [];
        self.popup = new app_popup(self);
        self.svg_cont = Snap("#svg");
        self.configUrl = self.settings.appUrl + "gf-apartments/" + self.settings.appID + "/config.json";
        self.imagesUrl = self.settings.appUrl + "gf-apartments/" + self.settings.appID;
        self.hasSvg = supportsSVG() ? true : false;
        self.preloader = new app_preloader(self);
        self.ajax = new app_ajax(self.settings.jsonUrl, 'single-apartment');
        self.dtable = null;
        self.activeHouse = 'ALL';

        //Get JSON CONFIG
        $.getJSON(self.configUrl, function (json) {
            self.settings.views = json.views;
            self.settings.width = json.width;
            self.settings.height = json.height;
            self.settings.info = json.info ? json.info : false;
            self.settings.view_names = json.view_names ? json.view_names : false;

            //Set images & svg depending on views in config!
            for (var i = 1; i < (self.settings.views + 1); i++) {
                self.settings.images.push(self.imagesUrl + "/view" + i + ".jpg");
                self.svgViews.push(self.imagesUrl + "/view" + i + ".svg");
            }

            var parameter = parseInt(getUrlParameterByName('house-view'));
            if (parameter > 0 && parseInt(self.settings.views) >= parameter) {
                self.defaultView = parameter;
            }

            $(window).trigger("apartment_construct_completed");

            init();
        });

        /** Construct DONE **/


        /**
         * Init
         * @returns {undefined}
         */
        var init = function () {

            $("body").addClass("apartment_selector").addClass(self.settings.theme);

            self.trace("Building App");
            //Generate CSS
            self.css = new app_css(self.dom_id, self.settings.appUrl);
            //Generate HTML
            self.html(new app_html(self.settings).gethtml());
            //Showing preloader
            self.preloader.show();
            //Setup json data
            self.setUpData();


        };
        
        /**
         * Get house by view number
         * 
         * @param {int} viewNumber 
         * @returns 
         */
        self.getHouseByViewNumber = function(viewNumber){
            
            switch (viewNumber) {
                case 2:
                case 3:
                    return 'H01';
                case 4:
                case 5:
                    return 'H02';
                case 6:
                case 7:
                    return 'H03';
                case 8:
                case 9:
                    return 'H04';
                case 10:
                case 11:
                    return 'H05';
                case 12:
                case 13:
                    return 'H06';
                case 14:
                case 15:
                    return 'H07';
                case 16:
                case 17:
                    return 'H08';
            }

            return 'ALL';

        };

        /**
         * Adding binds
         * @returns {undefined}
         */
        self.addBinds = function () {
            self.find(".changeView a:not('.external')").bind("click", self.changeView);
            self.find("input#showAll").change(self.toggleAllForSale);

            // self.find("input#hidesold").change(function(){
            //     if ($("input#hidesold").is(':checked')){
            //         $("body").find("path.sold,polygon.sold").css({ opacity: 0});
            //     }else{
            //         $("body").find("path.sold,polygon.sold").css({ opacity: 0.6 });
            //     }
            // });

            self.find("div.character > input").change(self.filterApparments);
            // self.find("div.forsalesold > input").change(self.filterApparments);
            
            if (self.defaultView == 1){
                self.find("#changeView1").trigger('click');
            }else{
                self.find("#changeView" + self.defaultView).trigger('click');
            }

            self.find('#switch-card span').bind("click", self.changeTypeOfView);

            self.filterApparments();

            self.preloader.hide();
            $("html").addClass("svg");

            $("body").find(".apartment_list tr.navigate").bind("click", self.trCLick);
            self.dtable = $('#apartmenttable').DataTable({
                "searching": true,
                "pageLength": self.settings.apartmentsInTable,
                "paging": self.settings.apartmentsInTable < self.apartments.length,
                "lengthChange": false,
                "responsive": true,
                pagingType: 'simple_numbers',
                columnDefs: [
                    {
                        type: "formatted-num",
                        targets: [5,6,7,8,9,10]
                    }
                ],
                fnDrawCallback: function (oSettings) {
                    if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                        $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                    } else{
                        $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                    }
                },
                language: {
                    emptyTable: "Tabellen innehåller ingen data",
                    info: "Viser _START_ til _END_ av _TOTAL_ leiligheter",
                    infoEmpty: "Det er ingen leiligheter å vise",
                    infoFiltered: "(filtrert fra totalt _MAX_ rader)",
                    infoPostFix: "",
                    infoThousands: " ",
                    lengthMenu: "Vis _MENU_ rader",
                    loadingRecords: "Laster...",
                    processing: "Bearbetar...",
                    search: "Søk:",
                    zeroRecords: "Fant ingen matchende leiligheter",
                    paginate: {
                        first: "Første",
                        last: "Siste",
                        next: "Neste",
                        previous: "Forrige"
                    },
                    aria: {
                        SortAscending: ": aktivera för att sortera kolumnen i stigande ordning",
                        SortDescending: ": aktivera för att sortera kolumnen i fallande ordning"
                    }
                },
                initComplete : function(){
                    $("#apartmenttable").wrap('<div class="apartments-table-responsive"></div>');
                }
            });
            self.trace("All binds loaded!");
        };

        self.changeTypeOfView = function(event){

            event.preventDefault();
            var btn = $(this);
            var id = btn.attr('id');
            self.find('#switch-card span').removeClass("active");
            btn.addClass('active');

            switch(id){
                case 'list':
                    $("body").find('table#apartmenttable').show();
                    $("body").find('div.apartment_cards').hide();
                    break;
                case 'card': 
                    $("body").find('table#apartmenttable').hide();
                    $("body").find('div.apartment_cards').show();
                    break;
            }

        }

        self.trCLick = function (event) {
            event.preventDefault();
            var tr = $(this);
            var id = tr.attr("data-id");
            var link = tr.attr("data-permalink");
            if(link !== ""){
                self.showApparment(id, link);
            }else{
               // console.log("no link..");
            }
        };

        /**
         * Fetching json data
         * @returns {undefined}
         */
        self.setUpData = function () {
            $.getJSON(self.settings.jsonUrl, function (json) {

                if (!$.isEmptyObject(json.apts)) {
                    var jsondata = json.apts;
                    self.trace("-----JSON DATA LOADED------");


                    $.each(jsondata, function (key, value) {

                        value.orig_lghnr = value.std_LghNr;
                        value.std_LghNr = value.std_LghNr.replace(/\./gi, '-');
                        value.std_LghNr = value.std_LghNr.replace(/[^a-zA-Z0-9-_]/gi, '');
                        value.std_LghNr = value.std_LghNr.replace(':', '_');
                        
                        console.log(value.std_LghNr); 

                        if(self.settings.theme === 'gfvyn'){
                            value.std_LghNr = value.std_LghNr.replace('-', '');
                        }

                        if (value.available === 'available' && typeof value.house !== undefined){
                            self.houses.forEach(function(house){
                                // console.log(house);
                                if(house.name === value.house){
                                    house.count++;
                                }
                            });
                        } 


                        //Dev Mode
                        if (value.available === "draft") {
                            return;
                        } else {
                            value.rooms = value.rooms.replace(",", ".");
                            value.roomsDisplay = value.rooms;
                            value.rooms = value.rooms.split("-");
                            value.rooms = missingNumbers(value.rooms);
                            value.size = value.size.replace(",", ".");

                            if (typeof value.bi_size != undefined){
                                value.bi_size = value.bi_size.replace(",", ".");
                            }else{
                                value.bi_size = "";
                            }
                            
                            self.apartments.push(value);
                        }
                    });

                    self.apartments.sort(SortByLgh);

                    self.trace("-----LOAD IMAGES------");
                    //Load images and setup slider!
                    app_preloadPictures(self.settings.images, self.setupSliders);
                    self.trace("-----JSON DATA COMPLETED------");

                } else {
                    self.remove();
                    // console.log("Could not load data");
                }
            });
        };

        /**
         * Setup app sliders!
         * @returns {undefined}
         */
        self.setupSliders = function () {

            // filter actions
            var highestArea = 0;
            var lowestArea = 999;
            var highestPrice = 10;
            var lowestPrice = 99999999999999;
            var lowestRoom = 1;
            var highestRoom = 1;

            for (var i in self.apartments) {
                lowestArea = (Number(self.apartments[i].size) < lowestArea) ? Number(self.apartments[i].size) : lowestArea;
                highestArea = (Number(self.apartments[i].size) > highestArea) ? Number(self.apartments[i].size) : highestArea;

                for (var x in self.apartments[i].rooms) {

                    if (Number(self.apartments[i].rooms[x]) > 0) {
                        lowestRoom = (Number(self.apartments[i].rooms[x]) < lowestRoom) ? Number(self.apartments[i].rooms[x]) : lowestRoom;
                        highestRoom = (Number(self.apartments[i].rooms[x]) > highestRoom) ? Number(self.apartments[i].rooms[x]) : highestRoom;
                    }
                }

                if (parseInt(self.apartments[i].price) > 0) {
                    lowestPrice = (Number(self.apartments[i].price) < lowestPrice) ? Number(self.apartments[i].price) : lowestPrice;
                    highestPrice = (Number(self.apartments[i].price) > highestPrice) ? Number(self.apartments[i].price) : highestPrice;
                }
            }

            if (lowestArea == highestArea) {
                lowestArea = 1;
            }

            if (lowestRoom == highestRoom) {
                lowestRoom = 1;
            }

            if (lowestPrice == highestPrice) {
                lowestPrice = 1;
                if (highestPrice == 1) {
                    highestPrice = 2;
                }
            }

            self.trace("Lowest Area: " + lowestArea);
            self.trace("Highest Area: " + highestArea);
            self.trace("Lowest Price: " + lowestPrice);
            self.trace("Highest Price: " + highestPrice);
            self.trace("Lowest Room: " + lowestRoom);
            self.trace("Highest Room: " + highestRoom);

            self.apartments.forEach(function(apartment){
                if(apartment.price === 0){
                    apartment.price = lowestPrice;
                }
            });

            self.roomSlider = new app_slider($("#sliderRum"), lowestRoom, highestRoom, $("#roomet"), false, self.filterApparments);
            self.areaSlider = new app_slider($("#sliderBo"), lowestArea, highestArea, $("#boarea"), "m²", self.filterApparments);
            self.priceSlider = new app_slider($("#sliderPrice"), lowestPrice, highestPrice, $("#price"), "kr", self.filterApparments);


            self.addBinds();
        };

        /**
         * Change view
         * @param {Event} event
         */
        self.changeView = function (event) {
            event.stopPropagation();
            event.preventDefault();
            var obj = $(this);
            var svg_cont = Snap("#svg");

            if (!obj.hasClass("active")) {
                var id = obj.attr("id");
                var did = obj.attr("data-id");
                var rid = obj.attr("data-rid");
                id = "view" + rid;

                $(".changeView").find("a").each(function(){

                    var data = $(this).data('visible'); 

                    if(data){
                        try{
                            var vis = data.toString().split(',');
                            
                            if (vis.indexOf(id.replace('view', '')) >= 0) {
                                $(this).show();
                            } else {
                                $(this).hide();
                            }
                        }catch(err){

                        }
                        
                    }
                    

                }).removeClass("active");

                obj.addClass("active");

                $(".view").hide();
                $("#" + id).show();

                self.activeView = "#" + id;
                self.trace("Showing view: #" + id);
                self.activeHouse = self.getHouseByViewNumber(parseInt(rid));
                // console.log(self);
                // console.log(self.getHouseByViewNumber(parseInt(rid)));

                svg_cont.clear();

                var lastClicked = null;
                //Snap.load($app.svgViews[did] + "?rand=" + Math.random() * 100, function (f) {
                //Snap.load($app.svgViews[did], function (f) {
                $(document).load(self.svgViews[did], function (f) {
                    f = Snap.parse(f);
                    var g = f.selectAll('polygon,path');
                    g.forEach(function (app) {
                        var id = app.node.id;
                        var isInfo = false;
                        if (id.indexOf("info_") !== -1) {
                            isInfo = true;
                        }

                        var poly = app;
                        if (self.getAppartment(id) && poly) {
                            poly.attr({'class': self.getAppartment(id).available, 'fill': ''});
                        } else if (isInfo && poly) {
                            var di = self.popup.get_info(id);
                            if(di.status && di.status != ""){
                                poly.attr({'class': di.status, 'fill': ''});
                            }else{
                                poly.attr({'class': 'info', 'fill': ''});
                            }
                        } else {
                            poly.attr({'class': 'not_for_sale', 'fill': ''});
                        }

                        poly.hover(function () {

                            var ww = $(window).outerWidth();

                            if(ww > 767){
                                if (isInfo) {
                                    self.popup.showPopUpInfo(id);
                                } else {
                                    self.popup.showPopUp(self.getAppartment(id));
                                }
                            }
                            



                        }, function () {

                                    self.popup.hidePopUp();
                                

                        }).click(function () {
                       
                            

                            if ((self.getAppartment(id).available == "available" || self.getAppartment(id).available == "sold" || self.getAppartment(id).available == "reserved" || self.getAppartment(id).available == "sell_later") || isInfo) {

                                

                                var ww = $(window).outerWidth();
                                var data = null;
                                var link = false;
                                var view = null;

                                if (isInfo) {

                                    // self.popup.showPopUpInfo(id);

                                    data = self.popup.get_info(id);


                                    if (data.link) {

                                        if(data.link.indexOf('popup:') !== -1){
                                            var url = data.link.replace('popup:','');
  
                                            $.featherlight(url);
                                            return false;
                                        }

                                        if(data.link.indexOf("view") !== -1){
                                            view = parseInt(data.link.replace("view","")) > 0 ? parseInt(data.link.replace("view","")) : 1;
                                            
                                            // return false;
                                        }else{
                                            return false;
                                        }
                                        link = data.link;
                                    }
                                } else {
                                    link = self.getAppartment(id).url;
                                }

                                if (ww > 768 || !self.settings.doubleClickOnDevice) {
                                    console.log("nodblclick")
                                    if (isInfo) {
                                        $("#changeView" + view).trigger("click");
                                    }else{
                                        if (self.getAppartment(id).available != "sold"){
                                            self.showApparment(id, link);
                                        }
                                    }
                                } else {

                                    // console.log("Click");

                                    if (id == lastClicked) {
                                        // console.log("Click 2");
                                        

                                        if(isInfo){
                                            self.popup.hidePopUp();
                                            $("#changeView" + view).trigger("click");
                                        } else if(self.getAppartment(id).available != "sold" ){
                                            self.popup.hidePopUp();
                                            self.showApparment(id, link);
                                        }

                                    }else{
                                        if (isInfo) {
                                            self.popup.showPopUpInfo(id);
                                        } else {
                                            self.popup.showPopUp(self.getAppartment(id));
                                        }
                                    }
                                }

                                if (id == lastClicked) {
                                    // console.log("Jee");
                                    lastClicked = null;
                                }else{
                                    lastClicked = id;
                                }

                            }

                            return false;
                            //location.href = apps[id].Url;
                        });

                    });

                    svg_cont.append(g);

                    self.filterApparments();
                    self.toggleAllForSale();
                });

            }
        };

        self.showApparment = function (id, link) {

            if (self.settings.navigate && link && link !== "") {
                
                if (self.settings.do_ajax) {
                    self.ajax.do_ajax(self.getAppartment(id).GUID);
                } else {
                    if(self.settings.new_page){
                        var win = window.open(link, '_blank');
                        win.focus();
                    }else{
                        window.location = link;
                    }

                }
            }
        };



        // filter apps: with slider and check
        self.filterApparments = function () {

            self.resetSvgElements();

            var allAppartments = [];
            for (var i in self.apartments) {
                allAppartments.push(self.apartments[i]);
            }

            // console.log(allAppartments);
            var highlights = [];

            //filter from values from sliders!
            var newAppartments = $.grep(allAppartments, function (s) {

                var result = true;

                // /**
                //  * Filter apps for each house
                //  * 
                //  */
                // if (self.activeHouse != 'ALL'){
                //     if (self.activeHouse != s.house){
                //         return false;
                //     }
                // } 
                
                  if (s.available === "no_sale") {
                    return true;
                  }


                // console.log("ROOMS", s.rooms);
                // console.log(s);

                if (typeof s.price === undefined || typeof s.size === undefined || typeof s.rooms === undefined)
                    return false;


                    
                
                    
                    var values = Array();
                    
                    self.find(".character input[name='character[]']:checked").each(function(elm){
                        values.push($(this).val());
                    });
                    
                    if(values.indexOf(s.character) == -1){
                        return false;
                    }

                    if (s.size == "-") {
                      return true;
                    }

                    // var forsalesold = [];
                    // self.find(".forsalesold input[name='forsalesold[]']:checked").each(function (elm) {
                    //     forsalesold.push($(this).val());
                    // });

                    // if (forsalesold.indexOf(s.available) == -1) {
                    //     return false;
                    // }

                    //forsalesold 

                    
                // console.log("Rooms", s.rooms);
                if (s.available === "sold") {
                    // console.log("hehehj2", result);
                    // return result;
                }
                


                    for (var p in s.rooms) {
                      if (
                        Number($("#sliderRum").slider("values", 0)) <=
                          Number(s.rooms[p]) &&
                        Number($("#sliderRum").slider("values", 1)) >=
                          Number(s.rooms[p]) &&
                        result
                      ) {
                        result = false;
                      }
                    }
                


                // if (s.available === "sold") {
                //     console.log("hehehj", result);
                //     return result;
                // }

                // return result;

                // console.log(s.sArkivNr, result);
                // if(result === true){
                // }else{
                //     console.log(s.price, s.available)
                // }

                return ((s.available !== "available" || s.available !== "reserved" || s.available !== "sold")
                        && (Number($("#sliderPrice").slider("values", 0)) <= Number(s.price) + 1)
                        && (Number($("#sliderPrice").slider("values", 1)) >= Number(s.price) - 1)
                        && (Number($("#sliderBo").slider("values", 0)) <= Number(s.size) + 1)
                        && (Number($("#sliderBo").slider("values", 1)) >= Number(s.size) - 1)
                        && !result);


            }, true);

            //self.showTable();
            var elementsToHide = [];

            //Highlight new apartments!
            for (var k in newAppartments) {
                //show filtered
                if (newAppartments[k].std_LghNr !== undefined) {
                    self.trace(newAppartments[k].std_LghNr);

                    var sid = newAppartments[k].std_LghNr;

                    if (sid !== undefined) {
                        var svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;
                        //var mySVG = $('#svg #' + sid).length ? $('#svg #' + sid) : null;

                        if (svg_element !== null) {
                            svg_element.addClass('filter');

                        }
                        elementsToHide.push(newAppartments[k].orig_lghnr);

                    }
                }
            }

            self.redraw(elementsToHide);
        };


        self.redraw = function (elementsToHide) {

            $("body").find('.apartment-fact-card').show();  
            for(var i =0; i<elementsToHide.length; i++){
                console.log(elementsToHide[i]);
                console.log(
                  '[data-id="' + elementsToHide[i].replace(".", "-") + '"]'
                );
                $("body").find('.apartment-fact-card[data-id="' + elementsToHide[i].replaceAll('.', '-') + '"]').hide();
            }

            if (self.dtable !== null) {

                $.fn.dataTable.ext.search.pop();
                self.dtable.draw();

                $.fn.dataTable.ext.search.push(
                        function (settings, data, dataIndex) {
                            
                            if(elementsToHide.length === 0){
                                return true;
                            }

                            return elementsToHide.indexOf(data[0]) === -1 ? true : false;
                        }
                );

                self.dtable.draw();
            }
        };



        /**
         * Show all apartments that are forsale
         * @todo redo whole function!
         * @returns {undefined}
         */
        self.toggleAllForSale = function () {

            var elementsToHide = [];

            for (var i in self.apartments) {
                //show filtered
                var svg_element = null;
                var sid = null;
                if ($("input#showAll").is(':checked')) {

                    $("body").find("path.sold,polygon.sold").css({opacity : 0.6});

                    // $("#controls div.checks, #controls #sliders, #controls #characterSelect, #controls #forsalesold").addClass('disabled');
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect").addClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (self.apartments[i]) {
                        if (sid !== undefined) {
                            svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;

                            if (svg_element !== null){
                                svg_element.addClass('hilight');
                                svg_element.removeClass('filter');
                            }

                        }
                    } else {
                            elementsToHide.push(sid);
                    }
                } else {

                    // if ($("input#hidesold").is(':checked')){
                    //     $("body").find("path.sold,polygon.sold").css({ opacity: 0 });
                    // } 
                    

                    // $("#controls div.checks, #controls #sliders, #controls #characterSelect, #controls #forsalesold").removeClass('disabled');
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect").removeClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (sid !== undefined) {
                        svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;
                        if (svg_element !== null)
                            svg_element.removeClass('hilight');
                    }
                }

            }

            if (!$("input#showAll").is(':checked')) {
                self.filterApparments();
            }else{
                self.redraw(elementsToHide);
            }

            
        };

        //Get one apartment from the apartments!
        self.getAppartment = function (id) {
            //Get apartment
            var ret = false;
            if (id !== "") {
                $.each(self.apartments, function (key, value) {
                    var obj = value;

                    if (obj.std_LghNr == id) {
                        ret = obj;
                        return false;
                    }
                });
            }

            if (id.indexOf("info_") !== -1) {
                return false;
            }

            if (!ret)
                self.trace("Didnt fin the apartment with ID: " + id);

            return ret;
        };

        /**
         * Reset svg elements
         * @returns {undefined}
         */
        self.resetSvgElements = function () {
            $('#svg polygon,#svg path').each(function () {
                var svg_element = this;
                if (svg_element !== null)
                    svg_element.removeClass('filter');
                    svg_element.removeClass('hilight');
            });
        };

        /**
         * Get nice status
         * @param {string} input
         * @returns {string}
         */
        self.statusTranslate = function (input) {
            for (var i in self.statusTypes) {
                if (input == self.statusTypes[i][0]) {

                    if(self  &&input === "available"){

                    }

                    return self.statusTypes[i][1];
                }
            }
        };

        //Trace statements
        self.trace = function (v, condebug) {
            if (self.settings.debug) {
                traceit(v, condebug, self);
            }
        };

    };

    $.extend($.fn.dataTableExt.oSort, {
        "formatted-num-pre": function (a) {
            a = a.replace(/[^\d\S\-\.\/a-zA-Z]/g, '');
            a = parseFloat(a);
            if (!isNaN(a)) {
                return a;
            } else {
                return '';
            }
        },
        "formatted-num-asc": function (a, b) {
            return a - b;
        },
        "formatted-num-desc": function (a, b) {
            return b - a;
        }
    });


    jQuery.fn.dataTableExt.aTypes.unshift(
        function (sData) {
            var deformatted = sData.replace(/[^\d\S\-\.\/a-zA-Z]/g, '');
            var isNumeric = !isNaN(deformatted - parseFloat(deformatted));

            return isNumeric || deformatted === "-" ?
                'formatted-num' :
                null;
        }
    );


})(jQuery, window, document, Snap, app_ajax);
